(function ($) {

    $(document).ready(function () {
      
      
        $('form#newsletter-footer').on('submit', function(){

          var idForm = $(this).attr("id");

          if (typeof gtag == 'function') {
            gtag('event', 'click', { 'event_category': 'formulario', 'event_label': idForm });
            gtag('event', 'form_' + idForm );
          };
          if (typeof ga == 'function') {
            ga('send','event', 'formulario', 'click', idForm );
          };
          if (typeof fbq == 'function') {
            fbq('track','Lead', {content_name: idForm });
          };


        });
      
      	      
        $('form.form-subscribe').on('submit', function(){

          var idForm = 'form-subscribe';

          if (typeof gtag == 'function') {
            gtag('event', 'click', { 'event_category': 'formulario', 'event_label': idForm });
            gtag('event', 'form_' + idForm );
          };
          if (typeof ga == 'function') {
            ga('send','event', 'formulario', 'click', idForm );
          };
          if (typeof fbq == 'function') {
            fbq('track','Lead', {content_name: idForm });
          };


        });

        /**
         * Asigna una clase en base al tipo de enlace
         */
        $('a[href^=tel]').addClass("link-phone");
        $('a[href^=mailto]').addClass("link-email").attr("target", "_blank");
		$('a[href*="wa.me"]').addClass("link-whatsapp").attr("target", "_blank");
      	$('a[href*="api.whatsapp"]').addClass("link-whatsapp").attr("target", "_blank");
		$('a[href*="m.me"]').addClass("link-messenger").attr("target", "_blank");
		$('a[href*="maps.google"]').addClass("link-map").attr("target", "_blank");
        $('#call-now-btn-floating-wrapper').addClass('link-phone');

        // Manejo de Eventos
        $('.link-phone').click(function () {
            if (typeof gtag == 'function') {
                gtag('event', 'click', { 'event_category': 'telefono', 'event_label': 'llamada' });
                gtag('event', 'click_llamada' );
            };
            if (typeof ga == 'function') {
                ga('send','event', 'telefono', 'click', 'llamada');
            };
            if (typeof fbq == 'function') {
                fbq('track','Contact', {content_name:'telefono'});
            };
        });

        $('.link-email').click(function () {
            if (typeof gtag == 'function') {
              gtag('event', 'click', { 'event_category': 'email', 'event_label': 'envio' });
              gtag('event', 'click_email' );
            }
            if (typeof ga == 'function') {
                ga('send', 'event', 'email', 'click', 'envio');
            };
            if (typeof fbq == 'function') {
                fbq('track','Contact', {content_name:'email'});
            };
        });

        $('.link-whatsapp').click(function () {
            if (typeof gtag == 'function') {
              gtag('event', 'click', { 'event_category': 'telefono', 'event_label': 'whatsapp' });
              gtag('event', 'click_whatsapp' );
            }
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'whatsapp');
            };
            if (typeof fbq == 'function') {
                fbq('track','Contact', {content_name:'whatsapp'});
            };
        });
        
        $('.link-messenger').click(function () {
            if (typeof gtag == 'function') {
                gtag('event', 'click', { 'event_category': 'telefono', 'event_label': 'messenger' });
            }
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'messenger');
            };
            if (typeof fbq == 'function') {
                fbq('track','Contact', {content_name:'messenger'});
            };
        });


        $('.link-map').click(function () {
            if (typeof gtag == 'function') {
                gtag('event', 'click', { 'event_category': 'site', 'event_label': 'map' });
            }
            if (typeof ga == 'function') {
                ga('send', 'event', 'site', 'click', 'map');
            };
            if (typeof fbq == 'function') {
                fbq('track','Contact', {content_name:'map'});
            };
		
        });
	    
	    
    });

})(jQuery);